/*
 * PageLoading.js
 * trt_cms2
 *
 * Created by Hisyam on 13/02/2020.
 * Copyright (c) 2020 Terato Tech. All rights reserved.
 */

import React from 'react';

function PageLoading(props) {
  return (
    <div className="preloader">
      <svg className="circular" viewBox="25 25 50 50">
        <circle className="path" cx="50" cy="50" r="20" fill="none" strokeWidth="2" strokeMiterlimit="10"/>
      </svg>
    </div>
  );
}

export default PageLoading;